import { Heading } from '@simplywallst/ui-core';
import { FeedContainer, RecentSectionUpdatesWrapper } from './styled';

import loadable from '@loadable/component';
import { MoreUpdates } from '@/pages/CompanyReport/components/Overview/components/RecentUpdates/components/MoreUpdates';
import type { EventCategory } from '@/constants/events';
import { slugify } from '@utilities/slugify';
import { useTranslation } from '@/hooks/useTranslation';
import { useVisibleSectionsIsPristine } from '@/pages/CompanyReport/components/VisibleSectionsContextProvider';

const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (component) => component.CompanyFeed,
});

interface RecentSectionUpdatesProps {
  title?: string;
  lookup: string;
  filterByEventCategory?: EventCategory;
}

const RecentSectionUpdates = ({
  title = 'Recent updates',
  lookup,
  filterByEventCategory,
}: RecentSectionUpdatesProps) => {
  const t = useTranslation();
  const isPristine = useVisibleSectionsIsPristine();

  return (
    <RecentSectionUpdatesWrapper
      templateRows="auto 1fr auto"
      rowGap="4px"
      data-cy-id={`introduction-${slugify(title)}`}
      className="bg-surface-2 print:bg-p-white"
    >
      <Heading as={isPristine ? 'h2' : 'h3'} typography="small">
        {title}
      </Heading>
      <FeedContainer>
        <CompanyFeed
          lookup={lookup}
          showLimit={6}
          isCompanyReport
          filterByEventCategory={filterByEventCategory}
          hoverBackground={'spaceGray'}
          titleElement={isPristine ? 'h3' : 'h4'}
        />
      </FeedContainer>
      <div className="absolute inset-x-0 bottom-0 h-x11 w-full bg-[linear-gradient(360deg,#202833_50%,rgba(32,40,51,0.3)_105.11%)] print:hidden" />
      <MoreUpdates
        lookup={lookup}
        menuTitle={title}
        filterByEventCategory={filterByEventCategory}
        buttonTitle={t('page.companyReport.feed.showAll')}
      />
    </RecentSectionUpdatesWrapper>
  );
};

export default RecentSectionUpdates;
